import Cookies from 'js-cookie';
import {jwtDecode} from 'jwt-decode';

export const getToken = () => {
  return Cookies.get('token');
};

export const decodeToken = () => {
  const token = getToken();
  if (token) {
    return jwtDecode(token);
  }
  return null;
};

export const isAuthenticated = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth-check`, {
        credentials: 'include', // Ensure cookies are sent and received
      });
      return response.ok;
    } catch (error) {
      console.error('Error checking auth:', error);
      return false;
    }
  };
  
  export const logout = () => {
    Cookies.remove('token');
  };